var components
try {
  components = {
    customTabbar: function () {
      return import(
        /* webpackChunkName: "components/custom-tabbar/custom-tabbar" */ "@/components/custom-tabbar/custom-tabbar.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = ((_vm.countData.salesAmount || 0) / 100).toFixed(2)
  var g1 = ((_vm.countData.settlementProfit || 0) / 100).toFixed(2)
  var l1 = _vm.__map(_vm.dataList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m0 = _vm.formatName(item.takeUser)
    var m1 = _vm.formatPhoneStar(item.takePhone) || ""
    var g2 =
      item.status === 5 && item.overdueStatus === 1
        ? ((item.overdueFee || 0) / 100).toFixed(2)
        : null
    var g3 =
      item.status === 5 && item.overdueStatus === 3
        ? ((item.overdueFee || 0) / 100).toFixed(2)
        : null
    var l0 = _vm.__map(item.detailList, function (item1, index1) {
      var $orig = _vm.__get_orig(item1)
      var g4 = ((item1.subtotal || 0) / 100).toFixed(2)
      return {
        $orig: $orig,
        g4: g4,
      }
    })
    var g5 = ((item.estimatedAmount || 0) / 100).toFixed(2)
    return {
      $orig: $orig,
      m0: m0,
      m1: m1,
      g2: g2,
      g3: g3,
      l0: l0,
      g5: g5,
    }
  })
  var g6 = !_vm.isLoadingMore ? !_vm.hasNext && _vm.dataList.length : null
  var g7 =
    !_vm.isLoadingMore && !g6 ? !_vm.hasNext && !_vm.dataList.length : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        l1: l1,
        g6: g6,
        g7: g7,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }